module.exports = __webpack_public_path__ + "static/media/facebook-logo.0cf21b83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-logo.svg
// module id = 177
// module chunks = 0